<template>
	<div>
		<div style="width:100%;height: 300px; 
		line-height:300px; vertical-align:middle;
		font-size: 80px;margin: 0 auto; text-align: center">{{corp}}</div>
		<div style="width:100%;height: 200px; 
		line-height:200px; vertical-align:middle;
		font-size: 80px;margin: 0 auto; text-align: center">债券资产管理云服务系统</div>
		
	</div>
</template>

<script>
	import {
		getIndexStatistics
	} from '../api/basisMG.js'

	// let echarts = require('echarts');
	let echarts = require('echarts/lib/echarts')
	// 引入饼状图组件
	require('echarts/lib/chart/pie')
	// 引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require("echarts/lib/component/legend");
	// 导出模块
	export default {

		// 模块数据
		data() {
			//数据  
			return {
				corp:"",
				userRoles:"",

				startTime: '',
				endTime: '',
				statisEndTime: '',
				statisStartTime: '',
				statistics: {},
				data1: [],
				charts: '',
				opinion: ['男', '女'],
				opinionData: [{
						value: 335,
						name: '男'
					},
					{
						value: 310,
						name: '女'
					},

				]
			}
		},


		watch: {},

		methods: {

			echartsData(id, title, lengendData, formData) {
				// 动态设置数据
				//   mychart.setOption({
				// legend :{
				//               data: names
				//           },
				//           series: [{
				//               data: brower
				//           }]
				//       });
				console.log(lengendData, formData)
				var myChart = echarts.init(document.getElementById(id));

				let option = {
					title: {
						text: title,
						left: 'center',
						top: 20,
						textStyle: {
							color: '#000',
							fontSize: 22
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b}:{c}({d}%)"
					},

					legend: {
						x: 'right',
						y: 'top',
						itemWidth: 25, // 标志图形的长度
						itemHeight: 25, // 标志图形的宽度
						right: 60,
						align: 'left',
						orient: 'vertical',
						padding: [10, 0, 0, 0],
						icon: 'circle',
						data: lengendData,
						textStyle: { //图例文字的样式
							color: '#000',
							fontSize: 16
						},
						formatter(name) {
							// console.log(option);
							let than = option.series[0].data; //获取series中的data
							// let total = 0;
							let tarValue;
							for (let i = 0, l = than.length; i < l; i++) {
								// total += than[i].value;
								if (than[i].name == name) {
									tarValue = than[i].value;
								}
							}
							// let p = (tarValue / total) * 100;
							// return name + " " + " " + tarValue + "%";
							return name + ": " + "¥" + tarValue;
						},

					},
					color: ['#4f81bc', '#bf504e', '#9bbb58', '#8064a1', '#f79647', '#4aacc5', '#a18864'],
					series: [{
							name: '访问来源',
							type: 'pie', // 设置图表类型为饼图
							radius: '55%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
							center: ['50%', '50%'],
							// roseType: 'angle',
							// avoidLabelOverlap: false,
							data: formData,
							label: {
								show: true,
								position: "outside",
								color: "#7F8FA4",
								fontSize: 12,
							},
							labelLine: {
								show: true,
							},
							//                     label: { normal: { show: true, formatter: '{b} \n ({d}%)',textStyle: {
							// 　　　　　　　　　　fontSize: 14, color: '#000',　}
							// 　　　　　　　　　 }},
							//                     label: { normal: { show: true, position: 'inner' ,formatter: '{b} \n \n{c} ({d}%)',textStyle: {
							// 　　　　　　　　　　fontSize: 14, color: '#fff',　}
							// 　　　　　　　　　 }},

						},
						{
							name: '访问来源',
							type: 'pie', // 设置图表类型为饼图
							radius: '55%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
							center: ['50%', '50%'],
							// roseType: 'angle',
							// avoidLabelOverlap: false,
							data: formData,
							label: {
								show: true,
								position: "inside",
								formatter: `{d}%`,
								textStyle: {
									fontSize: 14,
									color: '#fff',
								}
							},
							//                     label: { normal: { show: true, formatter: '{b} \n ({d}%)',textStyle: {
							// 　　　　　　　　　　fontSize: 14, color: '#000',　}
							// 　　　　　　　　　 }},
							//                     label: { normal: { show: true, position: 'inner' ,formatter: '{b} \n \n{c} ({d}%)',textStyle: {
							// 　　　　　　　　　　fontSize: 14, color: '#fff',　}
							// 　　　　　　　　　 }},

						}
					]
				}
				myChart.setOption(option);

			},

			getdata() {
				this.userRoles = sessionStorage.getItem('userrole')
				console.log("this.userRoles:",this.userRoles)
				if (this.userRoles =='5'){
					this.corp='北京天晟源基金管理有限公司'
				}
				if (this.userRoles =='6'){
					this.corp='北京中债融汇信息技术有限公司'
				}
				if (this.userRoles =='7'){
					this.corp='上海丹寅投资管理中心（有限合伙）'
				}
				if (this.userRoles =='10'){
					this.corp='卓然基金'
				}
				// this.getIndexStatistics()
			},
			// 获得所有用户标签
			getIndexStatistics() {
				let endTime = parseInt(this.endTime / 1000)
				let startTime = parseInt(this.startTime / 1000)
				getIndexStatistics({
					endTime,
					startTime
				}).then(res => {
					if (res.code == '200') {
						console.log(res)
						this.statistics = res.data
					}
				})

			},


		},
		// 创建前状态(里面是操作)
		beforeCreate() {
			
			// console.log('process.e
		},
		// 创建完毕状态(里面是操作)
		created() {
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {
		},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>
	.el-form-item {

		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}

	div {
		font-size: 18px;
		margin-top: 5px;
	}

	.font-bold {
		font-weight: bold;
		font-size: 36px;
	}

	.just-center {
		display: flex;
		justify-content: center;
	}

	.echartContian {
		width: 700px;
		height: 700px;
	}

	.canvasContain {
		float: left;
		width: 500px;
		height: 100%;
	}
</style>
